import React, { useContext } from "react"

import { AstuteContext } from "../context"
import { Show } from "./Show/index"
import { CheckingConsentRequirement } from "./CheckingConsentRequirement/index"
import { Consent } from "./Consent/index"
import { ConsentGranted } from "./ConsentGranted/index"
import { ConsentFailed } from "./ConsentFailed/index"
import { Failed } from "./Failed/index"
import { Report } from "./Report/index"

import { SCREENS } from "../reducer"

export const Views = () => {
  const {
    state: { view },
  } = useContext(AstuteContext)

  const screens = {
    [SCREENS.show]: () => <Show />,
    [SCREENS.checkingConsentRequirement]: () => <CheckingConsentRequirement />,
    [SCREENS.consent]: () => <Consent />,
    [SCREENS.consentFailed]: () => <ConsentFailed />,
    [SCREENS.consentGranted]: () => <ConsentGranted />,
    [SCREENS.failed]: () => <Failed />,
    [SCREENS.report]: () => <Report />,
  }

  return screens[view]()
}
